import { render, staticRenderFns } from "./CardPostSingle.vue?vue&type=template&id=755b95e2&"
import script from "./CardPostSingle.vue?vue&type=script&lang=js&"
export * from "./CardPostSingle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports